module.exports = __webpack_public_path__ + "static/media/sort_icon_default.a4d4628f.svg";